<h1 mat-dialog-title class="dialog-title">
    <mat-icon>edit_note</mat-icon>
    <span>Editar produtos em massa</span>
</h1>

<div mat-dialog-content class="dialog-content">
    <form [formGroup]="form">
        <div class="row">
            <!-- Linha 1 -->
            <div class="col-12 col-md-4 mb-3">
                <app-select-pesquisavel label="Unidade" [control]="$any(form.get('idUnidadeMedida'))"
                    [offlineList]="data.listaUnidadeMedida" idField="idUnidadeMedida" nameField="descricao" [isOptional]="true"
                    placeholder="Selecione">
                </app-select-pesquisavel>
            </div>
            <div class="col-12 col-md-4 mb-3">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>NCM</mat-label>
                    <input matInput formControlName="ncm" mask="0000.00.00" placeholder="Ex: 0000.00.00">
                </mat-form-field>
            </div>
            <div class="col-12 col-md-4 mb-3">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>CEST</mat-label>
                    <input matInput formControlName="cest" [mask]="masks.cest" placeholder="Ex: 00.000.00">
                </mat-form-field>
            </div>

            <!-- Linha 2 -->
            <div class="col-12 col-md-4 mb-3">
                <app-select-pesquisavel label="Origem" [control]="$any(form.get('idOrigemMercadoria'))"
                    [offlineList]="data.listaOrigemMercadoria" idField="id" nameField="descricao" [isOptional]="true"
                    placeholder="Selecione">
                </app-select-pesquisavel>
            </div>
            <div class="col-12 col-md-4 mb-3">
                <app-select-pesquisavel label="Categoria" [control]="$any(form.get('idCategoria'))"
                    [offlineList]="data.listaCategoria" idField="id" nameField="descricao" [isOptional]="true"
                    placeholder="Pesquisar...">
                </app-select-pesquisavel>
            </div>
            <div class="col-12 col-md-4 mb-3">
                <app-select-pesquisavel label="Fornecedor" [control]="$any(form.get('idFornecedor'))"
                    [apiUrl]="urlFornecedor" idField="id" nameField="descricao" [isOptional]="true"
                    placeholder="Nome do fornecedor">
                </app-select-pesquisavel>
            </div>

            <!-- Linha 3 -->
            <div class="col-12 col-md-4 mb-3">
                <app-select-pesquisavel label="Marca" [control]="$any(form.get('idMarca'))"
                    [offlineList]="data.listaMarca" idField="id" nameField="descricao" [isOptional]="true"
                    placeholder="Selecione">
                </app-select-pesquisavel>
            </div>
            <div class="col-12 col-md-4 mb-3">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Garantia</mat-label>
                    <input matInput formControlName="garantiaTexto" placeholder="Ex: 12 meses">
                </mat-form-field>
            </div>
            <div class="col-12 col-md-4 mb-3">
                <app-select-pesquisavel label="Linha de produto" [control]="$any(form.get('idLinhaProduto'))"
                    [offlineList]="data.listaLinhaProduto" idField="id" nameField="descricao" [isOptional]="true"
                    placeholder="Selecione">
                </app-select-pesquisavel>
            </div>

            <!-- Linha 4 -->
            <div class="col-12 col-md-4 mb-3">
                <app-select-pesquisavel label="Tipo item SPED" [control]="$any(form.get('idTipoItemSped'))"
                    [offlineList]="data.listaTipoItemSped" idField="id" nameField="descricao" [isOptional]="true"
                    placeholder="Selecione">
                </app-select-pesquisavel>
            </div>
            <div class="col-12 col-md-4 mb-3">
                <app-select-pesquisavel label="Permitir inclusão nas vendas"
                    [control]="$any(form.get('isPermitirVenda'))" [offlineList]="opcoesBooleano" idField="value"
                    nameField="descricao" [isOptional]="true" placeholder="Selecione">
                </app-select-pesquisavel>
            </div>
            <div class="col-12 col-md-4 mb-3">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Markup</mat-label>
                    <input matInput formControlName="markupPadrao" currencyMask [options]="maskDecimal2">
                </mat-form-field>
            </div>

            <!-- Linha 5 -->
            <div class="col-12 col-md-4 mb-3">
                <app-select-pesquisavel label="Ativo" [control]="$any(form.get('isAtivo'))"
                    [offlineList]="opcoesBooleano" idField="value" nameField="descricao" [isOptional]="true"
                    placeholder="Selecione">
                </app-select-pesquisavel>
            </div>
        </div>
    </form>

    <app-alert-card type="info" [closable]="false" class="mt-3">
        Campos em branco não serão atualizados
    </app-alert-card>
</div>

<div mat-dialog-actions align="end" class="mat-mdc-dialog-actions">
    <button mat-stroked-button class="btn-secondary" (click)="cancelar()" [disabled]="isLoading">Cancelar</button>
    <button mat-flat-button class="btn-primary" (click)="aplicar()" [disabled]="isLoading">
        @if(isLoading){ <mat-spinner diameter="20" color="accent"></mat-spinner> }
        @else { <span>Aplicar</span> }
    </button>
</div>